export default __webpack_public_path__ + "static/media/W_B_True.49540946.jpg";